<template>
  <div class="card">
    <div class="card-body p-0" style="hight: 40px">
      <div v-if="$parent.filtros.tipo_control != 4">
        <table
          style="font-size: 9px; overflow-x: auto"
          id="viajes"
          class="table table-bordered table-striped table-hover table-sm team-roster-table table-responsive text-nowrap"
        >
          <thead class="text-center">
            <tr>
              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Acciones
                </div>
                <div>
                  <button
                    type="button"
                    class="btn btn-primary btn-sm"
                    data-toggle="modal"
                    data-target="#modal-form-validate-viaje"
                    style="cursor: pointer"
                    v-if="
                      $parent.filtros.tipo_control == 1 &&
                        $parent.filtros.tipo_control &&
                        $parent.filtros.sitio_id &&
                        $parent.filtros.sitio_type
                    "
                  >
                    <i class="fas fa-plus"></i>
                  </button>
                </div>
              </th>
              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  # Viaje
                </div>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="filtros.idViaje"
                  placeholder="# Viaje"
                  @keyup.enter="$parent.getIndex()"
                />
              </th>
              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Ticket
                </div>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="filtros.ticket"
                  placeholder="Ticket"
                  @keyup.enter="$parent.getIndex()"
                />
              </th>
              <th>
                <div
                  class="font-weight-bold text-dark"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Tipo Producto
                </div>
              </th>

              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Vehículo
                </div>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="filtros.cabezote"
                  placeholder="Vehículo"
                  @keyup.enter="$parent.getIndex()"
                />
              </th>
              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Tipo combustible
                </div>
                <select
                  class="form-control form-control-sm"
                  v-model="filtros.tipo_combustible"
                  @change="$parent.getIndex()"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="tipo_combustible in objLista.tiposCombustible"
                    :key="tipo_combustible.numeracion"
                    :value="tipo_combustible.numeracion"
                  >
                    {{ tipo_combustible.descripcion }}
                  </option>
                </select>
              </th>
              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Remolque
                </div>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="filtros.nRemolque"
                  placeholder="Remolque"
                  @keyup.enter="$parent.getIndex()"
                />
              </th>
              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Conductor
                </div>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="filtros.nConductor"
                  placeholder="Conductor"
                  @keyup.enter="$parent.getIndex()"
                />
              </th>
              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Transportadora
                </div>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="filtros.nTransportadora"
                  placeholder="Transportadora"
                  @keyup.enter="$parent.getIndex()"
                />
              </th>
              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Ruta
                </div>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="filtros.ruta"
                  placeholder="Ruta"
                  @keyup.enter="$parent.getIndex()"
                />
              </th>
              <th class="text-center">
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Sitio cargue
                </div>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="filtros.nSitioCargue"
                  placeholder="Sitio Cargue"
                  @keyup.enter="$parent.getIndex()"
                />
              </th>
              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Sitio descargue
                </div>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="filtros.nSitioDescargue"
                  placeholder="Sitio Descargue"
                  @keyup.enter="$parent.getIndex()"
                />
              </th>
              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Últ. punto
                </div>
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="filtros.nUltPunto"
                  placeholder="Ult. Punto"
                  @keyup.enter="$parent.getIndex()"
                />
              </th>
              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Fecha Cita
                </div>
                <input
                  type="date"
                  class="form-control form-control-sm"
                  v-model="filtros.fecha_cita"
                  @keyup.enter="$parent.getIndex()"
                />
              </th>
              <th>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Hora Cita
                </div>
                <input
                  type="time"
                  class="form-control form-control-sm"
                  v-model="filtros.hora_cita"
                  @keyup.enter="$parent.getIndex()"
                />
              </th>
              <th v-if="$parent.filtros.tipo_control == 1">
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Estado del viaje
                </div>
                <select
                  class="form-control form-control-sm"
                  v-model="filtros.estado"
                  @change="$parent.getIndex()"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="estado in objLista.estados"
                    :key="estado.numeracion"
                    :value="estado.numeracion"
                  >
                    {{ estado.descripcion }}
                  </option>
                </select>
              </th>
              <th v-else>
                <div
                  class="font-weight-bold text-dark mb-1"
                  style="font-size: 10px; line-height: 1.2"
                >
                  Estado postulación
                </div>
                <select
                  class="form-control form-control-sm"
                  v-model="filtros.estado"
                  @change="$parent.getIndex()"
                >
                  <option value="">Seleccione...</option>
                  <option
                    v-for="estado in objLista.estadosPostulacion"
                    :key="estado.numeracion"
                    :value="estado.numeracion"
                  >
                    {{ estado.descripcion }}
                  </option>
                </select>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in viajes.data" :key="item.id">
              <td>
                <!-- Split dropright button -->
                <div
                  class="btn-group"
                  :class="viajes.data.length == 1 ? 'dropop' : 'dropright'"
                  style="position: static; z-index: auth"
                >
                  <button
                    type="button"
                    class="btn btn-dark btn-sm"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <i class="fas fa-align-justify"></i>
                  </button>
                  <div class="dropdown-menu" style="z-index: 10000">
                    <!-- Inspección Sitio -->
                    <a
                      class="dropdown-item"
                      data-toggle="modal"
                      data-target="#modal-form-inspeccion"
                      style="cursor: pointer"
                      v-if="
                        $parent.filtros.tipo_control == 1 &&
                          [1, 2, 4, 7].includes(item.estado) &&
                          item.estado != 15 &&
                          $parent.procesoInspeccion &&
                          $store.getters.can(
                            'hidrocarburos.ventanasOperaciones.inspeccionar',
                          )
                      "
                      @click="llenarModalInspeccion(item, 1)"
                    >
                      <i class="fas fa-binoculars"></i>
                      Inspección
                    </a>
                    <!-- Inspeccion Punto Gestión -->
                    <a
                      class="dropdown-item"
                      data-toggle="modal"
                      data-target="#modal-form-inspeccion"
                      style="cursor: pointer"
                      v-if="
                        item.estado != 15 &&
                          $parent.filtros.tipo_control == 2 &&
                          $parent.procesoInspeccion &&
                          $store.getters.can(
                            'hidrocarburos.ventanasOperaciones.inspeccionar',
                          )
                      "
                      @click="llenarModalInspeccion(item, 2)"
                    >
                      <i class="fas fa-binoculars"></i>
                      Inspección
                    </a>
                    <!-- Crear Viaje Postulacion -->
                    <a
                      class="dropdown-item"
                      style="cursor: pointer"
                      v-if="
                        $parent.filtros.tipo_control == 2 &&
                          $store.getters.can(
                            'plantaEx.ventanaOperaciones.crearViaje',
                          )
                      "
                      @click="validarViaje(item)"
                    >
                      <i class="fas fa-plus"></i>
                      Crear Viaje
                    </a>
                    <!-- Cambio Conductor -->
                    <a
                      class="dropdown-item"
                      data-toggle="modal"
                      data-target="#modal-form-cambio-trinomios"
                      style="cursor: pointer"
                      @click="llenarModalEntidad(item, 'Conductor')"
                      v-if="
                        $store.getters.can(
                          'plantaEx.ventanaOperaciones.cambiarConductor',
                        ) && $parent.filtros.tipo_control == 1
                      "
                    >
                      <i class="fas fa-exchange-alt"></i>
                      Cambiar Conductor
                    </a>
                    <!-- Cambio Vehículo -->
                    <a
                      class="dropdown-item"
                      data-toggle="modal"
                      data-target="#modal-form-cambio-trinomios"
                      style="cursor: pointer"
                      v-if="
                        $store.getters.can(
                          'plantaEx.ventanaOperaciones.cambiarVehiculo',
                        ) && $parent.filtros.tipo_control == 1
                      "
                      @click="llenarModalEntidad(item, 'Vehículo')"
                    >
                      <i class="fas fa-exchange-alt"></i>
                      Cambiar Vehículo
                    </a>
                    <!-- Cambio Remolque -->
                    <a
                      class="dropdown-item"
                      data-toggle="modal"
                      data-target="#modal-form-cambio-trinomios"
                      style="cursor: pointer"
                      v-if="
                        $store.getters.can(
                          'plantaEx.ventanaOperaciones.cambiarRemolque',
                        ) && $parent.filtros.tipo_control == 1
                      "
                      @click="llenarModalEntidad(item, 'Remolque')"
                    >
                      <i class="fas fa-exchange-alt"></i>
                      Cambiar Remolque
                    </a>
                    <!-- Calculo Planta Externa -->
                    <a
                      class="dropdown-item"
                      style="cursor: pointer"
                      data-toggle="modal"
                      data-target="#Modal_calc_planta_externa"
                      @click="
                        item.estado != 15 && (modalCalcPlantaExterna = true),
                          llenarModalCalculatorPlantaExterna(item)
                      "
                      v-if="
                        $store.getters.can(
                          'plantaEx.ventanaOperaciones.calcularApi',
                        ) &&
                          $parent.filtros.tipo_control == 1 &&
                          item.estado != 15 &&
                          item.tipo_producto.tipo_producto == 4 &&
                          item.ticket == null
                      "
                    >
                      <i class="fas fa-calculator"></i>
                      Calculo Planta Externa
                      <i
                        v-if="
                          item.volumen_calculado != null &&
                            item.volumen_calculado > 0
                        "
                        class="fas fa-check-circle"
                      ></i>
                      <i v-else class="fas fa-times-circle"></i>
                    </a>
                    <!-- Mapa Sitio -->
                    <a
                      class="dropdown-item"
                      data-toggle="modal"
                      data-target="#modal-form-mapa"
                      style="cursor: pointer"
                      v-if="
                        $store.getters.can(
                          'plantaEx.ventanaOperaciones.generarMapa',
                        ) && $parent.filtros.tipo_control == 1
                      "
                      @click="llenarModalMapa(item, item.cita_cargue)"
                    >
                      <i class="fa fa-map-marker-alt"></i>
                      Mapa
                    </a>
                    <!-- Mapa PuntoGestión -->
                    <a
                      class="dropdown-item"
                      data-toggle="modal"
                      data-target="#modal-form-mapa"
                      style="cursor: pointer"
                      v-if="
                        item.estado != 15 &&
                          $store.getters.can(
                            'plantaEx.ventanaOperaciones.generarMapa',
                          ) &&
                          $parent.filtros.tipo_control == 2
                      "
                      @click="
                        llenarModalMapa(
                          item,
                          item.det_plant_programacion.programacion.fecha,
                        )
                      "
                    >
                      <i class="fa fa-map-marker-alt"></i>
                      Mapa
                    </a>
                    <!-- Crear Ticket -->
                    <a
                      class="dropdown-item"
                      style="cursor: pointer"
                      v-if="
                        $parent.filtros.tipo_control == 1 &&
                          !item.numero_ticket &&
                          $store.getters.can(
                            'plantaEx.ventanaOperaciones.crearTicket',
                          )
                      "
                      @click="ticketForm(item)"
                    >
                      <i class="fas fa-ticket-alt"></i>
                      Crear Ticket
                    </a>
                    <!-- Imprimir Ticket -->
                    <a
                      class="dropdown-item"
                      style="cursor: pointer"
                      v-if="
                        $parent.filtros.tipo_control == 1 &&
                          item.numero_ticket &&
                          $store.getters.can(
                            'plantaEx.ventanaOperaciones.imprimirTicket',
                          )
                      "
                      @click="editarticketForm(item)"
                    >
                      <i class="fas fa-ticket-alt"></i>
                      Imprimir Ticket
                    </a>
                    <!-- Finalizar Viaje -->
                    <a
                      class="dropdown-item"
                      data-toggle="modal"
                      data-target="#modal-form-finalizar-viaje"
                      style="cursor: pointer"
                      v-if="
                        $parent.filtros.tipo_control == 1 &&
                          !item.numero_ticket &&
                          item.estado != 15 &&
                          $store.getters.can(
                            'plantaEx.ventanaOperaciones.finalizarViaje',
                          )
                      "
                      @click="llenarModalFinalizarViaje(item)"
                    >
                      <i class="fas fa-flag-checkered"></i>
                      Finalizar Viaje
                    </a>
                  </div>
                </div>
              </td>
              <td v-if="$parent.filtros.tipo_control == 1" class="text-center">
                <button
                  type="button"
                  class="btn btn-sm btn-default py-0"
                  data-toggle="modal"
                  data-target="#modal-form-detViaje"
                  @click="llenarModalDetViaje(item.id, item.tipo_operacion)"
                >
                  {{ item.id }}
                </button>
              </td>
              <td v-else></td>
              <td
                v-if="item.ticket !== null && item.ticket !== undefined"
                style="font-size: 11px"
              >
                <span class="badge badge-success">
                  {{ item.numero_ticket }}
                </span>
              </td>
              <td v-else style="font-size: 12px">
                <span class="badge badge-danger"> Sin Asignar </span>
              </td>
              <td>
                <div
                  v-if="
                    item.tipo_producto !== null &&
                      item.tipo_producto !== undefined
                  "
                >
                  {{ item.tipo_producto.nombre }}
                </div>
                <div v-else></div>
              </td>

              <td
                style="min-width: 60px; font-size: 12px"
                class="text-center"
                v-if="
                  (item.vehiculo != null &&
                    $parent.filtros.tipo_control == 1) ||
                    $parent.filtros.tipo_control == 2
                "
              >
                {{ item.vehiculo.placa }}
              </td>
              <td v-else></td>

              <td>
                <span
                  v-if="
                    (item.vehiculo != null &&
                      $parent.filtros.tipo_control == 1) ||
                      $parent.filtros.tipo_control == 2
                  "
                  class="badge ml-4 mr-4"
                  :class="
                    item.vehiculo.tipo_combustible == 1
                      ? 'badge-warning'
                      : 'badge-info'
                  "
                  >{{ item.vehiculo.nCombustible }}</span
                >
              </td>
              <td
                v-if="
                  ($parent.filtros.tipo_control == 2 ||
                    $parent.filtros.tipo_control == 1) &&
                    item.remolque != null
                "
              >
                {{ item.remolque.placa }}
              </td>
              <td v-else></td>
              <td
                v-if="
                  $parent.filtros.tipo_control == 1 ||
                    $parent.filtros.tipo_control == 2
                "
              >
                {{ item.conductor.nombres }} {{ item.conductor.apellidos }}
                <span class="badge badge-info">
                  {{ item.conductor.numero_documento }}
                </span>
              </td>
              <td v-if="$parent.filtros.tipo_control == 1">
                <div v-if="item.transportadora != null">
                  {{ item.transportadora.razon_social }}
                </div>
              </td>
              <td v-else>
                {{ item.det_plant_programacion.empresa.razon_social }}
              </td>
              <td
                v-if="
                  item.ruta != null &&
                    ($parent.filtros.tipo_control == 1 ||
                      $parent.filtros.tipo_control == 2)
                "
              >
                {{ item.ruta.nombre }}
              </td>
              <td v-else></td>
              <td class="text-nowrap">
                <div
                  v-if="
                    item.sitio_cargue != null &&
                      $parent.filtros.tipo_control == 1
                  "
                >
                  {{ item.sitio_cargue.nombre }}
                </div>
                <div v-if="$parent.filtros.tipo_control == 2">
                  {{ item.det_plant_programacion.origen.nombre }}
                </div>
              </td>
              <td v-if="item.sitio_descargue != null" class="text-nowrap">
                {{ item.sitio_descargue.nombre }}
              </td>
              <td v-else></td>
              <td v-if="$parent.filtros.tipo_control == 1" class="text-nowrap">
                {{ item.sitio.nombre }}
              </td>
              <td v-else></td>
              <td v-if="$parent.filtros.tipo_control == 1" class="text-nowrap">
                {{ ((item.cita_cargue || "").split(" ")[0] || "").trim() }}
              </td>

              <td v-if="$parent.filtros.tipo_control == 1" class="text-nowrap">
                {{ ((item.cita_cargue || "").split(" ")[1] || "").trim() }}
              </td>
              <td v-if="$parent.filtros.tipo_control == 2" class="text-nowrap">
                {{ (item.det_plant_programacion.fecha_cita || "").trim() }}
              </td>
              <td v-if="$parent.filtros.tipo_control == 2" class="text-nowrap">
                {{ (item.det_plant_programacion.cita || "").trim() }}
              </td>
              <td class="text-center" style="font-size: 12px">
                <span
                  class="badge"
                  :class="
                    item.estado == 1 || item.estado == 7
                      ? 'badge-primary'
                      : item.estado == 6 || item.estado == 9
                      ? 'bg-navy'
                      : item.estado == 5 || item.estado == 10
                      ? 'badge-info'
                      : item.estado == 4 || item.estado == 2
                      ? 'badge-success'
                      : item.estado == 3
                      ? 'badge-danger'
                      : 'badge-dark'
                  "
                >
                  {{ item.estado }}. {{ item.estadoViaje }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="card-footer">
          <div class="float-left" v-if="viajes.total">
            Mostrando del <b>{{ viajes.from }}</b> al <b>{{ viajes.to }}</b> de
            un total: <b>{{ viajes.total }}</b> Registros
          </div>
          <div class="float-left" v-else>
            <span class="badge badge-danger">
              No hay registros para mostrar
            </span>
          </div>
          <pagination
            :data="viajes"
            @pagination-change-page="$parent.getIndex"
            :limit="5"
            class="float-right m-0"
          >
          </pagination>
        </div>
      </div>
    </div>
    <!-- Modal Calculo Planta Externa -->
    <div
      class="modal fade"
      id="Modal_calc_planta_externa"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">
              Calcular volumenes planta externa
            </h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal2"
              @click="limpiarModalCalculatorPlantaExterna()"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <!-- Cuerpo del modal -->
          <div class="modal-body">
            <calculator-planta-externa
              v-if="modalCalcPlantaExterna"
              :pVehiculo="form.vehiculo"
              :pRemolque="form.remolque"
              ref="calculatorPlantaExterna"
            />
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-sm btn-success"
              @click="selectVolumenPlantaExterna()"
            >
              <i class="fas fa-check-circle"></i>Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
    <VentanaOperacionesFinalizarViaje
      ref="FinalizarViaje"
      @actualizar="$parent.getIndex()"
    />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { VBPopover } from "bootstrap-vue";
import pagination from "laravel-vue-pagination";
import CalculatorPlantaExterna from "../../../../components/CalculatorPlantaExterna.vue";
import VentanaOperacionesFinalizarViaje from "./VentanaOperacionesFinalizarViaje.vue";

export default {
  name: "PlantVentanaOperacionesViajes",
  components: {
    pagination,
    CalculatorPlantaExterna,
    VentanaOperacionesFinalizarViaje,
  },
  directives: {
    "b-popover": VBPopover,
  },
  data() {
    return {
      form: {
        vehiculo: null,
        remolque: null,
      },
      viajes: {},
      viaje: {},
      postuladoTerceros: {},
      filtros: {},
      filtrosTerceros: {},
      sitio_type: null,
      fechaAct: null,
      solicitudDiaria: [],
      objLista: {
        estados: [],
        estadosPostulacion: [],
        tiposCombustible: [],
      },
      sitio_id: null,
      modalCalcCrudo: false,
      modalCalcPlantaExterna: false,
      modalCalcVentasTerceros: false,
      volumen_calculado: 0,
      peso_vehiculo: 0,
      peso_remolque: 0,
      api: 0,
      uri_docs: process.env.VUE_APP_AWS_BUCKET_URL,
    };
  },

  methods: {
    validarViaje(postulacion) {
      let hoy = new Date();

      let form_viaje = {
        vehiculo_id: postulacion.vehiculo.id,
        conductor_id: postulacion.conductor.id,
        remolque_id: postulacion.remolque.id,

        transportadora_id: postulacion.det_plant_programacion.empresa.id,

        tipo_producto_id: postulacion.det_plant_programacion.tipo_producto,
        tipo_vehiculo_id: postulacion.det_plant_programacion.tipo_vehiculo_id,

        sitio_cargue_id: postulacion.det_plant_programacion.origen_id,

        sitio_descargue_id: postulacion.det_plant_programacion.destino_id,

        fecha_inicial: `${hoy.getFullYear()}-${hoy.getMonth() +
          1}-${hoy.getDate()}`,

        hora_inicial: `${hoy.getHours()}:${hoy.getMinutes()}:${hoy.getSeconds()}`,

        det_postulacion_id: postulacion.id,

        celular_conductor: postulacion.conductor.celular_principal,

        orden_de_cargue: postulacion.orden_cargue,

        link_orden_cargue: postulacion.link_orden_cargue,

        clase_viaje: 1,

        sitio_type:
          this.$parent.filtros.sitio_type == 1
            ? "App\\PlantSitio"
            : "App\\PlantPuntoGestion",

        sitio_id: this.$parent.filtros.sitio_id,

        tipo_operacion: 1,

        estado: this.$parent.filtros.sitio_type == 1 ? 7 : 1,

        fecha_cita: postulacion.det_plant_programacion.programacion.fecha,

        hora_cita: postulacion.det_plant_programacion.fecha_cita.slice(0, 10),

        cita_cargue: postulacion.det_plant_programacion.programacion.fecha_cita,
      };

      this.$swal({
        title: "Esta a punto de crear un viaje para la postulacion ",
        html: `Conductor: ${postulacion.conductor.nombres} ${
          postulacion.conductor.apellidos
        } <br>
                Vehiculo: ${postulacion.vehiculo.placa} <br>
                Remolque: ${postulacion.remolque?.placa ||
                  "No presenta remolque"} <br>
                Transportadora: ${
                  postulacion.det_plant_programacion.empresa.razon_social
                } <br>                 
                <b>Desea crear un viaje para esta postulacion?<b>`,
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Si, Crear!",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          this.$swal({
            title: "Esta seguro de crear el viaje ?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Si, Crear!",
            cancelButtonText: "Cancelar",
          }).then((result) => {
            if (result.value) {
              this.$parent.$refs.VentanaOperacionesValidateViaje.crearViaje(
                form_viaje,
              );
            }
          });
        }
      });
    },

    fechaActual() {
      this.fechaAct = moment().format("YYYY-MM-DD HH:mm:ss");
      this.fechaCorte = moment(this.fechaAct)
        .add(-1, "hours")
        .format("YYYY-MM-DD HH:mm:ss");
    },

    async selectVolumenPlantaExterna() {
      this.volumen_calculado = await this.$refs.calculatorPlantaExterna
        .max_barriles;
      let api = await this.$refs.calculatorPlantaExterna.API;
      axios
        .put("/api/plant/ventanasEnturnamientoOperacion/guardarVolumenes", {
          params: {
            volumen_calculado: this.volumen_calculado,
            api: api,
            viaje_id: this.form.viaje_id,
          },
        })
        .then(() => {
          this.$refs.closeModal2.click();
          this.modalCalcCrudo = false;
          this.form = {};
          this.$parent.getIndex();
          this.$swal({
            icon: "success",
            title: "Se guardaron correctamente los valor GSV Y API",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        })
        .catch((e) => {
          this.cargando = false;
          this.$refs.closeModal2.click();
          this.$swal({
            icon: "error",
            title: "Ocurrió un error, vuelva a intentarlo..." + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    limpiarModalCalculatorPlantaExterna() {
      this.modalCalcPlantaExterna = false;
      this.form = {};
      this.volumen_calculado = 0;
    },

    llenarModalEntidad(viaje, entidad) {
      this.$parent.$refs.VentanaOperacionesCambios.getIndex(viaje, 2, entidad);
    },

    llenarModalFinalizarViaje(viaje) {
      this.$refs.FinalizarViaje.abrir(viaje);
    },

    llenarModalCalculatorPlantaExterna(viaje) {
      this.form = {};
      this.form.vehiculo = viaje.vehiculo;
      this.form.viaje_id = viaje.id;
      if (viaje.remolque) {
        this.form.remolque = viaje.remolque;
      }
    },

    llenarModalInspeccion(viaje, tipo) {
      this.$parent.$refs.VentanaOperacionesInspeccion.llenar_modal_inspeccion(
        viaje,
        tipo,
      );
    },

    llenarModalMapa(item, fecha) {
      this.$parent.$refs.VentanaOperacionesMapa.llenar_modal_mapa(item, fecha);
    },

    llenarModalDetViaje(viaje, tipo_control) {
      this.$parent.$refs.ViajesDetViaje.llenar_modal_detViaje(
        viaje,
        tipo_control,
      );
    },

    ticketForm(viaje) {
      return this.$router.push({
        name: "/plantaExterna/ticketForm",
        params: {
          accion: "Asignar",
          viaje,
          tipo_control: this.$parent.filtros.tipo_control,
          sitio_id: this.$parent.filtros.sitio_id,
          sitio_type: this.$parent.filtros.sitio_type,
        },
      });
    },

    editarticketForm(viaje) {
      return this.$router.push({
        name: "/plantaExterna/ticketForm",
        params: {
          accion: "Editar",
          viaje,
          tipo_control: this.$parent.filtros.tipo_control,
          sitio_id: this.$parent.filtros.sitio_id,
          sitio_type: this.$parent.filtros.sitio_type,
        },
      });
    },

    getEstados() {
      axios.get("/api/lista/39").then((response) => {
        this.objLista.estados = response.data;
      });
    },

    getEstadosPostulacion() {
      axios.get("/api/lista/65").then((response) => {
        this.objLista.estadosPostulacion = response.data;
      });
    },

    getTiposCombustibles() {
      axios.get("/api/lista/24").then((response) => {
        this.objLista.tiposCombustible = response.data;
      });
    },
  },

  mounted() {
    this.fechaActual();
    this.getEstados();
    this.getEstadosPostulacion();
    this.getTiposCombustibles();

    if (this.$route.params.recargar) {
      this.$parent.getIndex();
    }
  },
};
</script>
<style>
.my-swal {
  z-index: 20000 !important;
}
#viajes thead th {
  vertical-align: top;
}
</style>
